// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const ENVIRONMENT_NAME = process.env.ENVIRONMENT_NAME || process.env.NEXT_PUBLIC_ENVIRONMENT_NAME;
const IS_DEV = ENVIRONMENT_NAME === 'development';

if (!IS_DEV) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT_NAME,
    release: process.env.VERSION,
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
  });
}
